import React from 'react';

import './ArticleLink.scss';

type Props = {
  url: string;
  icon: string;
  title: string;
  description: string;
  authorAvatars: Array<string>;
};

function ArticleLink({ url, title, description, authorAvatars, icon }: Props) {
  return (
    <a
      className="ArticleLink d-flex w-100 px-3 py-1 cursor-pointer mb-2"
      rel="noopener noreferrer"
      href={url}
      target="_blank"
    >
      <img className="align-self-center" src={icon} alt={icon} />
      <div className="d-flex flex-column ml-3">
        <div className="ArticleLink__title">{title}</div>
        <div className="ArticleLink__description">{description}</div>
        <div className="d-flex mt-1">
          {authorAvatars.map(avatar => (
            <img key={avatar} className="ArticleLink__avatar" src={avatar} alt={avatar} />
          ))}
        </div>
      </div>
    </a>
  );
}

export default ArticleLink;
